export const columbusPharmacies = [
    // Chain Pharmacies near OSU
    {
        id: 'cvs-high-st',
        name: 'CVS Pharmacy',
        address: '1375 N High St, Columbus, OH 43201',
        phone: '(614) 291-8508'
    },
    {
        id: 'walgreens-high-st',
        name: 'Walgreens',
        address: '1335 N High St, Columbus, OH 43201',
        phone: '(614) 297-3194'
    },
    {
        id: 'walgreens-lane-ave',
        name: 'Walgreens',
        address: '1569 W Lane Ave, Columbus, OH 43221',
        phone: '(614) 486-5332'
    },
    {
        id: 'rite-aid-high-st',
        name: 'Rite Aid',
        address: '1471 N High St, Columbus, OH 43201',
        phone: '(614) 294-5025'
    },
    {
        id: 'kroger-king-ave',
        name: 'Kroger Pharmacy',
        address: '1350 King Ave, Columbus, OH 43212',
        phone: '(614) 488-6301'
    },
    {
        id: 'giant-eagle-lane-ave',
        name: 'Giant Eagle Pharmacy',
        address: '1955 W Lane Ave, Columbus, OH 43221',
        phone: '(614) 486-5336'
    },
    {
        id: 'walmart-olentangy',
        name: 'Walmart Pharmacy',
        address: '1675 Olentangy River Rd, Columbus, OH 43212',
        phone: '(614) 294-4792'
    },
    {
        id: 'target-graceland',
        name: 'Target Pharmacy',
        address: '1871 N High St, Columbus, OH 43210',
        phone: '(614) 294-0928'
    },
    // Hospital/Medical Center Pharmacies
    {
        id: 'osu-wexner-main',
        name: 'OSU Wexner Medical Center Pharmacy',
        address: '660 Ackerman Rd, Columbus, OH 43202',
        phone: '(614) 293-8136'
    },
    {
        id: 'osu-ambulatory-care',
        name: 'OSU Ambulatory Care Pharmacy',
        address: '2050 Kenny Rd, Columbus, OH 43221',
        phone: '(614) 293-8700'
    },
    {
        id: 'osu-student-health',
        name: 'OSU Wilce Student Health Pharmacy',
        address: '1875 Millikin Rd, Columbus, OH 43210',
        phone: '(614) 292-4321'
    },
    {
        id: 'ohiohealth-riverside',
        name: 'OhioHealth Riverside Methodist Hospital Pharmacy',
        address: '3535 Olentangy River Rd, Columbus, OH 43214',
        phone: '(614) 566-5000'
    },
    {
        id: 'mount-carmel',
        name: 'Mount Carmel West Hospital Pharmacy',
        address: '793 W State St, Columbus, OH 43222',
        phone: '(614) 234-5000'
    },
    // Independent Pharmacies
    {
        id: 'campus-pharmacy',
        name: 'Campus Pharmacy',
        address: '2465 N High St, Columbus, OH 43202',
        phone: '(614) 267-3233'
    },
    {
        id: 'neil-avenue-pharmacy',
        name: 'Neil Avenue Pharmacy',
        address: '1487 Neil Ave, Columbus, OH 43201',
        phone: '(614) 299-3447'
    },
    {
        id: 'grandview-heights-pharmacy',
        name: 'Grandview Heights Pharmacy',
        address: '1265 Grandview Ave, Columbus, OH 43212',
        phone: '(614) 486-3144'
    },
    {
        id: 'olde-town-pharmacy',
        name: 'Olde Town Pharmacy',
        address: '5570 N High St, Columbus, OH 43214',
        phone: '(614) 885-3121'
    },
    {
        id: 'clintonville-pharmacy',
        name: 'Clintonville Pharmacy',
        address: '3496 N High St, Columbus, OH 43214',
        phone: '(614) 262-3066'
    },
    // Additional Chain Locations
    {
        id: 'cvs-kenny-rd',
        name: 'CVS Pharmacy',
        address: '2115 Kenny Rd, Columbus, OH 43221',
        phone: '(614) 457-0463'
    },
    {
        id: 'cvs-bethel-rd',
        name: 'CVS Pharmacy',
        address: '1500 Bethel Rd, Columbus, OH 43220',
        phone: '(614) 451-8837'
    },
    {
        id: 'meijer-sawmill',
        name: 'Meijer Pharmacy',
        address: '1499 W Lane Ave, Columbus, OH 43221',
        phone: '(614) 481-9095'
    },
    // Additional Chain Pharmacies - Columbus
    {
        id: 'walgreens-specialty',
        name: 'Walgreens Specialty Pharmacy',
        address: '114 W 3rd Ave, Columbus, OH 43201',
        phone: '(614) 456-1108'
    },
    {
        id: 'walgreens-n-high-1782',
        name: 'Walgreens',
        address: '1782 N High St, Columbus, OH 43201',
        phone: '(614) 493-4350'
    },
    {
        id: 'walgreens-5th-ave',
        name: 'Walgreens',
        address: '1444 W 5th Ave, Grandview Heights, OH 43212',
        phone: '(614) 486-3308'
    },
    {
        id: 'walgreens-broad-st',
        name: 'Walgreens',
        address: '2770 W Broad St, Columbus, OH 43204',
        phone: '(614) 276-9745'
    },
    {
        id: 'walgreens-livingston',
        name: 'Walgreens',
        address: '3015 E Livingston Ave, Columbus, OH 43209',
        phone: '(614) 236-8622'
    },
    {
        id: 'kroger-bexley',
        name: 'Kroger Pharmacy',
        address: '2000 E Main St, Columbus, OH 43205',
        phone: '(614) 252-1064'
    },
    {
        id: 'kroger-brewers-yard',
        name: 'Kroger Pharmacy',
        address: '150 W Sycamore St, Columbus, OH 43215',
        phone: '(614) 340-7980'
    },
    {
        id: 'kroger-clintonville',
        name: 'Kroger Pharmacy',
        address: '3417 N High St, Columbus, OH 43214',
        phone: '(614) 263-1796'
    },
    {
        id: 'kroger-northland',
        name: 'Kroger Pharmacy',
        address: '1745 Morse Rd, Columbus, OH 43229',
        phone: '(614) 405-9401'
    },
    {
        id: 'cvs-downtown',
        name: 'CVS Pharmacy',
        address: '109 S High St, Columbus, OH 43215',
        phone: '(614) 222-4261'
    },
    {
        id: 'cvs-livingston',
        name: 'CVS Pharmacy',
        address: '591 E Livingston Ave, Columbus, OH 43215',
        phone: '(614) 462-4800'
    },
    {
        id: 'cvs-neil-ave',
        name: 'CVS Pharmacy',
        address: '759 Neil Ave, Columbus, OH 43215',
        phone: '(614) 229-2750'
    },
    {
        id: 'cvs-n-high-2160',
        name: 'CVS Pharmacy',
        address: '2160 N High St, Columbus, OH 43201',
        phone: '(614) 292-1050'
    },
    // Chain Pharmacies - Suburbs
    {
        id: 'walgreens-grove-city',
        name: 'Walgreens',
        address: '2110 Stringtown Rd, Grove City, OH 43123',
        phone: '(614) 277-1325'
    },
    {
        id: 'walgreens-dublin',
        name: 'Walgreens',
        address: '6805 Hospital Dr, Dublin, OH 43016',
        phone: '(614) 336-0431'
    },
    {
        id: 'walgreens-westerville',
        name: 'Walgreens',
        address: '748 N State St, Westerville, OH 43082',
        phone: '(614) 865-0352'
    },
    {
        id: 'cvs-grove-city',
        name: 'CVS Pharmacy',
        address: '3575 Broadway, Grove City, OH 43123',
        phone: '(614) 875-0261'
    },
    {
        id: 'cvs-dublin',
        name: 'CVS Pharmacy',
        address: '305 W Bridge St, Dublin, OH 43017',
        phone: '(614) 766-3829'
    },
    {
        id: 'cvs-westerville',
        name: 'CVS Pharmacy',
        address: '145 S State St, Westerville, OH 43081',
        phone: '(614) 882-2735'
    },
    {
        id: 'kroger-stringtown',
        name: 'Kroger Pharmacy',
        address: '2474 Stringtown Rd, Grove City, OH 43123',
        phone: '(614) 875-0596'
    },
    {
        id: 'giant-eagle-dublin',
        name: 'Giant Eagle Pharmacy',
        address: '6700 Perimeter Loop Rd, Dublin, OH 43017',
        phone: '(614) 717-9424'
    },
    {
        id: 'giant-eagle-westerville',
        name: 'Giant Eagle Pharmacy',
        address: '650 N State St, Westerville, OH 43082',
        phone: '(614) 895-3645'
    },
    {
        id: 'discount-drug-mart',
        name: 'Discount Drug Mart',
        address: '2290 Stringtown Rd, Grove City, OH 43123',
        phone: '(614) 539-4880'
    },
    {
        id: 'meijer-grove-city',
        name: 'Meijer Pharmacy',
        address: '2811 London Groveport Rd, Grove City, OH 43123',
        phone: '(614) 801-4310'
    },
    // Independent Pharmacies
    {
        id: 'uptown-pharmacy',
        name: 'Uptown Pharmacy',
        address: '23 N State St, Westerville, OH 43081',
        phone: '(614) 882-2392'
    },
    {
        id: 'trio-pharmacy',
        name: 'Trio Pharmacy',
        address: '1570 Cleveland Ave, Columbus, OH 43211',
        phone: '(614) 298-8180'
    },
    {
        id: 'crosbys-drugs',
        name: 'Crosbys Drugs Inc.',
        address: '2609 N High St, Columbus, OH 43202',
        phone: '(614) 267-9424'
    },
    {
        id: 'phillips-pharmacy',
        name: 'Phillips Pharmacy',
        address: '1017 Mount Vernon Ave, Columbus, OH 43203',
        phone: '(614) 252-3440'
    },
    {
        id: 'edwards-drugs',
        name: 'Edwards Drugs',
        address: '1083 Mount Vernon Ave, Columbus, OH 43203',
        phone: '(614) 252-9527'
    },
    {
        id: 'friends-pharmacy',
        name: 'Friends Pharmacy Inc.',
        address: '2872 W Broad St, Columbus, OH 43204',
        phone: '(614) 279-5500'
    },
    {
        id: 'central-ohio-compounding',
        name: 'Central Ohio Compounding Pharmacy',
        address: '262 Neil Ave, Columbus, OH 43215',
        phone: '(614) 228-4476'
    },
    {
        id: 'doctors-pharmacy-downtown',
        name: 'Doctors Pharmacy Downtown',
        address: '270 S Grant Ave, Columbus, OH 43215',
        phone: '(614) 464-5000'
    },
    {
        id: 'bioscrip-pharmacy',
        name: 'Bioscrip Pharmacy Services',
        address: '5700 Perimeter Dr, Dublin, OH 43017',
        phone: '(877) 410-0132'
    },
    {
        id: 'aperture-rx',
        name: 'Aperture Rx',
        address: '6185 Shamrock Ct, Dublin, OH 43016',
        phone: '(614) 761-0000'
    },
    {
        id: 'soleo-health',
        name: 'Soleo Health Inc.',
        address: '6190 Shamrock Ct, Dublin, OH 43016',
        phone: '(614) 760-0960'
    },
    {
        id: 'genoa-healthcare',
        name: 'Genoa Healthcare, LLC',
        address: '525 Metro Pl N, Dublin, OH 43017',
        phone: '(614) 340-7990'
    },
    // Additional Suburban Locations
    {
        id: 'cvs-hilliard',
        name: 'CVS Pharmacy',
        address: '4651 Cemetery Rd, Hilliard, OH 43026',
        phone: '(614) 777-9988'
    },
    {
        id: 'walgreens-hilliard',
        name: 'Walgreens',
        address: '3700 Main St, Hilliard, OH 43026',
        phone: '(614) 876-5585'
    },
    {
        id: 'kroger-hilliard',
        name: 'Kroger Pharmacy',
        address: '4651 Cemetery Rd, Hilliard, OH 43026',
        phone: '(614) 529-2590'
    },
    {
        id: 'giant-eagle-hilliard',
        name: 'Giant Eagle Pharmacy',
        address: '4000 Britton Pkwy, Hilliard, OH 43026',
        phone: '(614) 771-8800'
    },
    {
        id: 'walmart-hilliard',
        name: 'Walmart Pharmacy',
        address: '3600 Fishinger Blvd, Hilliard, OH 43026',
        phone: '(614) 529-1130'
    },
    {
        id: 'cvs-reynoldsburg',
        name: 'CVS Pharmacy',
        address: '7350 E Main St, Reynoldsburg, OH 43068',
        phone: '(614) 864-4618'
    },
    {
        id: 'walgreens-reynoldsburg',
        name: 'Walgreens',
        address: '1635 Brice Rd, Reynoldsburg, OH 43068',
        phone: '(614) 864-4618'
    },
    {
        id: 'kroger-reynoldsburg',
        name: 'Kroger Pharmacy',
        address: '1925 Brice Rd, Reynoldsburg, OH 43068',
        phone: '(614) 575-9000'
    },
    {
        id: 'cvs-gahanna',
        name: 'CVS Pharmacy',
        address: '1213 N Hamilton Rd, Gahanna, OH 43230',
        phone: '(614) 471-0667'
    },
    {
        id: 'walgreens-gahanna',
        name: 'Walgreens',
        address: '630 Morrison Rd, Gahanna, OH 43230',
        phone: '(614) 471-1004'
    },
    {
        id: 'giant-eagle-gahanna',
        name: 'Giant Eagle Pharmacy',
        address: '765 Morrison Rd, Gahanna, OH 43230',
        phone: '(614) 428-8500'
    },
    {
        id: 'kroger-gahanna',
        name: 'Kroger Pharmacy',
        address: '1650 Watermark Dr, Columbus, OH 43215',
        phone: '(614) 586-7700'
    },
    // Additional Independent Pharmacies
    {
        id: 'hometown-pharmacy',
        name: 'Hometown Pharmacy',
        address: '4561 Cemetery Rd, Hilliard, OH 43026',
        phone: '(614) 529-2500'
    },
    {
        id: 'reynoldsburg-pharmacy',
        name: 'Reynoldsburg Pharmacy',
        address: '7350 E Main St, Reynoldsburg, OH 43068',
        phone: '(614) 864-4618'
    },
    {
        id: 'gahanna-pharmacy',
        name: 'Gahanna Pharmacy',
        address: '94 N Stygler Rd, Gahanna, OH 43230',
        phone: '(614) 471-1004'
    },
    {
        id: 'dublin-pharmacy',
        name: 'Dublin Pharmacy',
        address: '75 N High St, Dublin, OH 43017',
        phone: '(614) 889-2555'
    },
    {
        id: 'westerville-pharmacy',
        name: 'Westerville Pharmacy',
        address: '8 E College Ave, Westerville, OH 43081',
        phone: '(614) 882-6135'
    }
];
// Medication options for the dropdown
export const medicationOptions = [
    { value: 'adderall', label: 'Adderall (amphetamine/dextroamphetamine)' },
    { value: 'adderall-xr', label: 'Adderall XR (extended-release)' },
    { value: 'vyvanse', label: 'Vyvanse (lisdexamfetamine)' },
    { value: 'concerta', label: 'Concerta (methylphenidate ER)' },
    { value: 'ritalin', label: 'Ritalin (methylphenidate)' },
    { value: 'ritalin-la', label: 'Ritalin LA (long-acting)' },
    { value: 'focalin', label: 'Focalin (dexmethylphenidate)' },
    { value: 'focalin-xr', label: 'Focalin XR (extended-release)' },
    { value: 'strattera', label: 'Strattera (atomoxetine)' },
    { value: 'wellbutrin', label: 'Wellbutrin (bupropion)' },
    { value: 'dexedrine', label: 'Dexedrine (dextroamphetamine)' },
    { value: 'mydayis', label: 'Mydayis (mixed amphetamine salts)' },
    { value: 'qelbree', label: 'Qelbree (viloxazine)' },
    { value: 'other', label: 'Other (please specify in notes)' }
];
// Dosage options for ADHD medications
export const dosageOptions = [
    // Adderall IR
    { value: '5mg', label: '5 mg' },
    { value: '7.5mg', label: '7.5 mg' },
    { value: '10mg', label: '10 mg' },
    { value: '12.5mg', label: '12.5 mg' },
    { value: '15mg', label: '15 mg' },
    { value: '20mg', label: '20 mg' },
    { value: '25mg', label: '25 mg' },
    { value: '30mg', label: '30 mg' },
    // Vyvanse specific
    { value: '40mg', label: '40 mg' },
    { value: '50mg', label: '50 mg' },
    { value: '60mg', label: '60 mg' },
    { value: '70mg', label: '70 mg' },
    // Concerta specific
    { value: '18mg', label: '18 mg' },
    { value: '27mg', label: '27 mg' },
    { value: '36mg', label: '36 mg' },
    { value: '54mg', label: '54 mg' },
    { value: '72mg', label: '72 mg' },
    // Focalin specific
    { value: '2.5mg', label: '2.5 mg' },
    { value: '35mg', label: '35 mg' },
    { value: 'other', label: 'Other (specify in notes)' }
];
// Day supply options
export const daySupplyOptions = [
    { value: '30', label: '30 days' },
    { value: '60', label: '60 days' },
    { value: '90', label: '90 days' }
];
